import classNames from "classnames";
import AppContext from "PFApp/app_context";
import Content from "PFApp/feed/parts/content";
import Header from "PFApp/feed/parts/header";
import LearningAndDevelopment from "PFApp/feed/parts/learning_and_development";
import useIsFeatureEnabled from "PFCore/helpers/use_is_feature_enabled";
import { useCurrentProfile } from "PFCore/hooks/queries/profile/use_current_profile";
import { FeatureFlag } from "PFTypes";
import PropTypes from "prop-types";
import React, { useContext, useEffect, useMemo, useState } from "react";

import css from "./feed.less";

const FeedPage = ({
  tab,
  setTab,
  tasks,
  fetchActivities,
  fetchActivitiesDocs,
  saveInterestedSkill,
  showFilters,
  toggleFilters,
  clearFilters,
  handleOrderChange,
  handleFilterChange,
  handleFiltersReplace,
  clearRefValue,
  handleEditPost,
  postTask,
  fetchCourses,
  fetchRssFeed,
  filtersAreClear
}) => {
  const { appLayout } = useContext(AppContext).store;
  const { data: currentProfile } = useCurrentProfile();
  const isEnabled = useIsFeatureEnabled();
  const hasAccessToActivities = useMemo(() => {
    const ownPermissions =
      currentProfile?.permissions_group?.cross_group_permissions[currentProfile?.permissions_group?.id];
    return ownPermissions && Object.entries(ownPermissions.activities_access_levels).length > 0;
  }, [firstLoad]);

  const isOneColumn = appLayout.mainWidth <= 900;
  const isLearningAndDevelopmentVisible = isEnabled(FeatureFlag.LearningAndDevelopment);
  const [firstLoad, setFirstLoad] = useState(true);

  useEffect(() => {
    if (tab === "my_feed" && tasks?.meta?.total === 0 && firstLoad && hasAccessToActivities) {
      // this redirects to all_activities when empty list
      setTab("all_activities");
    }
    setFirstLoad(false);
  }, [firstLoad]);

  return (
    <>
      <div
        className={classNames(css.wrapper, {
          [css.isOneColumn]: isOneColumn
        })}
      >
        <div
          className={classNames(css.leftColumn, {
            [css.columnCollapsed]: isOneColumn,
            [css.wideLeftColumn]: !isLearningAndDevelopmentVisible,
            [css.noSideColumn]: !isLearningAndDevelopmentVisible
          })}
        >
          <div className={css.leftColumnInner}>
            <Header
              key={tab} // we need that to refresh selected saved filters
              fetchActivities={fetchActivities}
              fetchActivitiesDocs={fetchActivitiesDocs}
              tab={tab}
              setTab={setTab}
              saveInterestedSkill={saveInterestedSkill}
              toggleFilters={toggleFilters}
              showFilters={showFilters}
              tasks={tasks}
              handleOrderChange={handleOrderChange}
              handleFilterChange={handleFilterChange}
              handleFiltersReplace={handleFiltersReplace}
              clearFilters={clearFilters}
              clearRefValue={clearRefValue}
              postTask={postTask}
              filtersAreClear={filtersAreClear}
            />
            <Content
              tasks={tasks}
              fetchActivities={fetchActivities}
              tab={tab}
              handleEditPost={handleEditPost}
              isSideBarVisible={isLearningAndDevelopmentVisible}
              isOneColumn={isOneColumn}
            />
          </div>
        </div>
        {isLearningAndDevelopmentVisible && (
          <LearningAndDevelopment
            isOneColumn={isOneColumn}
            fetchCourses={fetchCourses}
            fetchRssFeed={fetchRssFeed}
          />
        )}
      </div>
    </>
  );
};

FeedPage.propTypes = {
  tasks: PropTypes.shape({
    entries: PropTypes.array,
    meta: PropTypes.object
  }),
  fetchActivities: PropTypes.func,
  fetchActivitiesDocs: PropTypes.func,
  saveInterestedSkill: PropTypes.func,
  toggleFilters: PropTypes.func,
  tab: PropTypes.string,
  setTab: PropTypes.func,
  showFilters: PropTypes.bool,
  handleOrderChange: PropTypes.func,
  handleFilterChange: PropTypes.func,
  handleFiltersReplace: PropTypes.func,
  clearFilters: PropTypes.func,
  clearRefValue: PropTypes.number,
  handleEditPost: PropTypes.func,
  postTask: PropTypes.object,
  fetchCourses: PropTypes.func,
  fetchRssFeed: PropTypes.func,
  filtersAreClear: PropTypes.bool
};

export default FeedPage;
